<p *ngIf="quantity <= PRODUCT_PRICE_CONST.ProductQuantityOne">
  {{ product.price | currency:'EUR':true }}
</p>
<p *ngIf="quantity <= PRODUCT_PRICE_CONST.ProductQuantityTwo  && quantity > PRODUCT_PRICE_CONST.ProductQuantityOne">
  {{ product.price_2 | currency:'EUR':true }}
</p>
<p *ngIf="quantity <= PRODUCT_PRICE_CONST.ProductQuantityThree && quantity > PRODUCT_PRICE_CONST.ProductQuantityTwo">
  {{ product.price_3 | currency:'EUR':true }}
</p>
<p *ngIf="quantity > PRODUCT_PRICE_CONST.ProductQuantityThree">
  {{ product.price_4 | currency:'EUR':true }}
</p>
